import React from "react";

import Error404 from "../../error/Error404";

function Blog() {
  return (
    <div>
      <Error404 />
    </div>
  );
}

export default Blog;
